export default {
  message: "Contact",
  toConfirmed: "To be confirmed",
  toConfirmed2: "To be confirmed",
  to: "To",
  confirmed: "Confirmed",
  employe: 'Employe',
  highMatching: "High matching",
  mediumMatching: "Medium matching",
  lowMatching: "Low matching",
  details: "Details",
  assignEmployees: "Assign employees",
  employeeSearch: "Enter employee name to search"
}